import { useContext, useEffect, useState } from "react";
import DaysScroll from "./ui/DaysScroll";
import CustomSnackbar from "./ui/CustomSnackbar";
import { snackBarConfigType } from "../classes/SnackBarConfig";
import UserProgress, { QURAN_SURAH, VersesInfo } from "../classes/UserProgress";
import SurahVerseSelector from "./ui/SurahVerseSelector";
import { GlobalContext } from "../contexts/GlobalContext";
import { fetchUserProgress, writeNewProgressToFB } from "../services/firebase";
import { useNavigate, useParams } from "react-router-dom";

const LogProgress = () => {
  const navigate = useNavigate();
  const { currentUser, getCurrentUser } = useContext(GlobalContext);

  const [selectedDay, setSelectedDay] = useState<number>(new Date().getDate());
  const [isLoading, setIsLoading] = useState({ text: "", state: false });

  const [fromSurah, setFromSurah] = useState(QURAN_SURAH[0].number);
  const [fromVerse, setFromVerse] = useState(1);

  const [toSurah, setToSurah] = useState(QURAN_SURAH[0].number);
  const [toVerse, setToVerse] = useState(1);

  const [lastUserProgressTo, setLastUserProgressTo] = useState<VersesInfo>({
    book: "quran",
    chapter: 1,
    verse: 1,
  });

  let [snackBarConfig, setSnackBarConfig] = useState<snackBarConfigType>({
    open: false,
    severity: "success",
    message: "",
  });

  const isValidInputs = () => {
    console.log("selectedDay", selectedDay);
    console.log("fromSurah", fromSurah);
    console.log("fromVerse", fromVerse);
    console.log("toSurah", toSurah);
    console.log("toVerse", toVerse);
    console.log("------------------");

    if (toSurah > fromSurah || (toSurah === fromSurah && toVerse > fromVerse)) {
      return true;
    } else {
      setSnackBarConfig({
        open: true,
        severity: "error",
        message: "Invalid Progress Range!",
      });
      return false;
    }
  };

  const saveProgress = () => {
    if (!isValidInputs()) return;

    // Save progress to the database
    setIsLoading({ text: "Saving Progress...", state: true });

    const fromProgress: VersesInfo = {
      book: "Quran",
      chapter: fromSurah,
      verse: fromVerse,
    };
    const toProgress: VersesInfo = {
      book: "Quran",
      chapter: toSurah,
      verse: toVerse,
    };

    const currentTimeInMS = Date.now();

    const userProgress: UserProgress = {
      id: `${currentTimeInMS}`,
      progressFrom: fromProgress,
      progressTo: toProgress,
      status: 0,
      created_at: currentTimeInMS,
      user_id: currentUser.id,
    };

    // Save to the database
    writeNewProgressToFB(userProgress)
      .then(() => {
        setIsLoading({ text: "", state: false });

        setSnackBarConfig({
          open: true,
          severity: "success",
          message: "Progress Saved Successfully!",
        });
        setTimeout(() => {
          navigate("/home");
        }, 2000);
      })
      .catch((error) => {
        setIsLoading({ text: "", state: false });

        setSnackBarConfig({
          open: true,
          severity: "error",
          message: "Failed to save progress!, " + error,
        });
      });
  };

  const { progressId } = useParams(); // Get progressId from URL

  useEffect(() => {
    if (progressId) {
      // Fetch progress details if progressId exists
      console.log("Fetching progress for ID:", progressId);
      setIsLoading({ text: "Loading...", state: true });

      // Add API call here
      fetchUserProgress(currentUser.id, progressId).then((userProgressData) => {
        setIsLoading({ text: "Saving Progress...", state: false });

        console.log("User progress", userProgressData);
        try {
          const userProgress = userProgressData as UserProgress;
          const verseInfo = userProgress.progressTo;

          setFromSurah(verseInfo.chapter);
          setFromVerse(verseInfo.verse);
        } catch (error) {
          setIsLoading({ text: "Saving Progress...", state: false });

          setSnackBarConfig({
            open: true,
            severity: "error",
            message: "Failed to get last progress!, " + error,
          });
        }
      });
    }
  }, [progressId]);

  return (
    <>
      <CustomSnackbar snackbarConfig={snackBarConfig} />
      <div className="mx-4 my-10">
        <h1 className="font-grgrifter text-[2.8rem] tracking-wider text-[#AFAEB3] mb-10 w-full text-center">
          Log Progress
        </h1>
      </div>
      <div className="flex flex-col">
        <h2 className="mx-4  text-3xl text-[#1B1B1B] mb-4">Select Date</h2>

        <DaysScroll selectedDay={selectedDay} setSelectedDay={setSelectedDay} />
      </div>
      <div className="mx-4 my-10">
        <div className="w-full flex flex-col">
          <h2 className=" text-3xl text-[#1B1B1B]">Select Progress</h2>
          <div className="w-full flex flex-col justify-center items-center my-6">
            <SurahVerseSelector
              fromSurah={fromSurah}
              fromVerse={fromVerse}
              setToSurah={setToSurah}
              setToVerse={setToVerse}
              toSurah={toSurah}
              toVerse={toVerse}
            />
          </div>
        </div>

        {isLoading.state ? (
          <button className="w-full flex items-center justify-center px-6 py-4 bg-[#3A9437] rounded-full cursor-pointer mb-10">
            <p className="w-3em font-grgrifter text-[1.5em] tracking-wider  text-left text-white">
              {isLoading.text}
            </p>
          </button>
        ) : (
          <button
            className="w-full flex items-center justify-center px-6 py-4 bg-[#3A9437] rounded-full cursor-pointer mb-10"
            type="submit"
            onClick={saveProgress}
          >
            <p className="w-3em font-grgrifter text-[1.5em] tracking-wider  text-left text-white">
              Allhamdulillah!
            </p>
          </button>
        )}
      </div>
    </>
  );
};

export default LogProgress;
